// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xPartNumberStyle } from "@eisinc/App/SharedStyles/ProductPartNumberStyle";
import { partNumberStyles } from "@eisinc/Overrides/Widgets/ProductDetails/ProductDetailsPartNumber";
import { color, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

partNumberStyles.labelText = xPartNumberStyle.label;
partNumberStyles.valueText = xPartNumberStyle.value;
partNumberStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 8px 22px;
        padding-bottom: 12px;
        margin-bottom: 12px;
        ${xScreen("gt", "sm")} {
            border-bottom: 1px solid ${color("common.border")};
        }
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};
partNumberStyles.skeletonWrapper = {
    css: css`
        margin-top: 4px;
        padding-bottom: 12px;
        margin-bottom: 12px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};
